<script setup lang="ts">
import UserAvatarNamed from "@/components/ui/UserAvatar/UserAvatarNamed.vue";
import type { AuthUser } from "@/model/user";

defineProps<{ editor: AuthUser }>();
</script>

<template>
  <div
    data-ignore-click
    class="sticky-note-locked-overlay"
    @pointerdown.prevent.stop
    @click.stop.prevent
  />

  <div data-ignore-click class="sticky-note-locked-chip">
    <UserAvatarNamed :user="editor" black />
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/variables/colors";
@use "@/styles/z-index";

.sticky-note-locked-overlay {
  position: absolute;
  inset: 0;
  outline: 1px solid colors.$palette-brand-100;
}

.sticky-note-locked-chip {
  position: absolute;
  top: -20px;
  left: 8px;
  z-index: z-index.$board-controls;
}
</style>
